/**
 * How a module's diff status and a field change's kind are painted.
 *
 * @module components/portfolio/comparison/module-status
 */

import type { ModuleDifferenceStatus } from "@/components/portfolio/comparison/diff-types";
import type { BadgeTone } from "@/components/ui";
import type { RevisionFieldChange } from "@/server/governance-diff";

export const MODULE_STATUS_DETAILS: Record<
  ModuleDifferenceStatus,
  { label: string; tone: BadgeTone }
> = {
  new: { label: "New", tone: "success" },
  removed: { label: "Removed", tone: "error" },
  edited: { label: "Edited", tone: "warning" },
  // `info` in the screen this replaces, which `BadgeTone` does not carry.
  // `primary` is the nearest: a change of placement rather than of content,
  // so it is not the amber an edit gets.
  moved: { label: "Moved", tone: "primary" },
  unchanged: { label: "Unchanged", tone: "ghost" },
};

/**
 * The tone a field change's kind is drawn in.
 *
 * @param kind - Whether the field was added, removed or amended.
 * @returns The badge tone for it.
 */
export function changeKindTone(kind: RevisionFieldChange["kind"]): BadgeTone {
  if (kind === "added") {
    return "success";
  }
  if (kind === "removed") {
    return "error";
  }
  return "warning";
}
